var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61628 14.6342C4.20516 14.6342 3.84961 14.4871 3.54961 14.1929C3.24961 13.8982 3.09961 13.5398 3.09961 13.1176V4.55091H2.34961V3.03424H5.89961V2.26758H10.0829V3.03424H13.6496V4.55091H12.8996V13.1176C12.8996 13.5398 12.7496 13.8982 12.4496 14.1929C12.1496 14.4871 11.7941 14.6342 11.3829 14.6342H4.61628ZM11.3829 4.55091H4.61628V13.1176H11.3829V4.55091ZM5.93294 11.8342H7.34961V5.83424H5.93294V11.8342ZM8.64961 11.8342H10.0663V5.83424H8.64961V11.8342Z",
    fill: "#831D16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.536afcc88ea1c079c8d6263024e90290.svg";
export { ForwardRef as ReactComponent };